
export const common = {
  // Navigation
  collections: 'Collections',
  about: 'About',
  contact: 'Contact',
  getQuote: 'Get Quote',
  
  // Hero Section
  heroSubtitle: 'We supply homes and projects. Marble, tiles, home finishes -- we have it all.',
  exploreCollections: 'Explore Collections',
  contactWhatsApp: 'Contact us on WhatsApp',
  checkLinkTree: 'Check out our LinkTree',
  
  // Collections
  premiumCollections: 'Our Premium Collections',
  collectionsDescription: 'Discover our extensive range of premium building materials, from natural marble to locally manufactured Saudi tiles',
  
  // Collection Types
  'collection.marble.title': 'Premium Marble',
  'collection.marble.description': 'Exquisite marble varieties from around the world',
  'collection.saudi_ceramic.title': 'Saudi Ceramic',
  'collection.saudi_ceramic.description': 'Locally manufactured ceramic tiles supporting Saudi Vision 2030',
  'collection.saudi_porcelain.title': 'Saudi Porcelain',
  'collection.saudi_porcelain.description': 'High-quality porcelain tiles manufactured locally in Saudi Arabia',
  'collection.explore_more.title': 'Explore More',
  'collection.explore_more.description': 'Discover our complete range of premium building materials and comprehensive services',
  
  // Product Details
  size: 'Size',
  thickness: 'Thickness',
  origin: 'Origin',
  category: 'Category',
  finish: 'Finish',
  
  // Services
  professionalConsultation: 'Professional Consultation',
  consultationDescription: 'Get expert consultation for your building material needs. Our professional team will help you choose the perfect materials for your project, provide technical specifications, and offer comprehensive project planning services tailored to your requirements.',
  requestConsultation: 'Request Consultation',
  productSpecifications: 'Product Specifications',
  pricingInformation: 'Pricing Information',
  professionalServices: 'Professional Services',
  
  // About Section
  aboutTitle: 'About Prime Materials',
  aboutDescription: 'Prime Materials is a leading supplier of premium building materials in Saudi Arabia, committed to excellence and supporting Saudi Vision 2030 through local manufacturing and international partnerships.',
  premiumQuality: 'Premium Quality',
  premiumQualityDesc: 'Carefully selected materials from trusted global suppliers',
  localManufacturing: 'Local Manufacturing',
  localManufacturingDesc: 'Supporting Saudi Vision 2030 with locally manufactured products',
  expertService: 'Expert Service',
  expertServiceDesc: 'Professional consultation and installation services',
  
  // Trusted Clients
  trustedClients: 'Trusted by Leading Entities',
  trustedClientsDesc: 'Proud to serve some of the most prestigious entities in Saudi Arabia',
  
  // Contact Section
  contactDescription: 'Ready to start your project? Contact us for expert consultation and quotes',
  phone: 'Phone',
  email: 'Email',
  location: 'Location',
  
  // Menu Links
  callUs: 'Call Us',
  emailUs: 'Email Us',
  findUs: 'Find Us',
  
  // Footer
  footerDescription: 'Excellence in building materials, crafting exceptional spaces across Saudi Arabia',
  services: 'Services',
  contactInfo: 'Contact Info',
  naturalStones: 'Natural Stones',
  highEndPorcelain: 'High-End Porcelain',
  materialConsultation: 'Material Consultation',
  projectPlanning: 'Project Planning',
  installation: 'Installation',
  customOrders: 'Custom Orders'
};

export default common;
